import Layout from "components/layout/Layout";
import LoginContent from "../../components/login/LoginContent";
import { useLocation, useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";
import { ProviderUtils } from "utils/providerUtils";
import CardLayout from "components/layout/CardLayout";

const LoginPage = () => {
  const navigate = useNavigate();
  const intl = useIntl();
  const location = useLocation();
  const isJTRPage = location.state?.isJTRPage;

  // 이전 페이지가 JTR 관련 페이지인 경우, 뒤로 가기 시 Activity Home으로 redirect
  const onBack = () => {
    navigate(isJTRPage ? "/activity" : "/");
  };

  return ProviderUtils.loginAvailable ? (
    <Layout onBack={onBack} text={intl.formatMessage({ id: "signup.login" })}>
      <LoginContent isModal={false} />
    </Layout>
  ) : (
    <div className="flex min-h-[80vh] w-full items-center justify-center px-4">
      <CardLayout className="mt-4 flex w-full">
        <div className="flex items-center justify-center py-3">
          <p className="text-center text-lg font-bold leading-10">
            장기간 이용이 없었습니다.
            <br /> 안전한 이용을 위해 다시 접속해주세요.
          </p>
        </div>
      </CardLayout>
    </div>
  );
};

export default LoginPage;
